module.exports = __webpack_public_path__ + "img/i_phd.7a8dae32.svg";